export default __webpack_public_path__ + "static/media/salesforce.fc8b11b0.svg";